import { ChangeEvent, useMemo, useState } from "react";
import "../../ui/elements/input.scss";

type InputPasswordProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
};

export const InputPassword = ({
  value,
  onChange,
  label = "Пароль",
  name = "password",
  id,
  placeholder = "Введіть пароль",
  required = false,
  disabled = false,
}: InputPasswordProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const inputId = useMemo(() => id ?? `input-${name}`, [id, name]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="input">
      <label className="input__label" htmlFor={inputId}>
        {label}
      </label>
      <div className="input__control">
        <input
          className="input__field"
          id={inputId}
          name={name}
          type={isVisible ? "text" : "password"}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          autoComplete="current-password"
          required={required}
          disabled={disabled}
        />
        <button
          className="input__toggle"
          type="button"
          onClick={() => setIsVisible((prevState) => !prevState)}
          aria-label={isVisible ? "Скрыть пароль" : "Показать пароль"}
        >
          <img
            src={!isVisible ? "/img/icons/visibility-off.png" : "/img/icons/visibility.png"}
            alt={!isVisible ? "Скрыть пароль" : "Показать пароль"}
          />
        </button>
      </div>
    </div>
  );
};
